import { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PreventivoBuilder from "./pages/PreventivoBuilder";
import PresentationView from "./pages/PresentationView";
import SharedPresentation from "./pages/SharedPresentation";
import Dashboard from "./pages/Dashboard";
import LoginPage from "./pages/LoginPage";
import { Toaster } from "./components/ui/sonner";

const BACKEND_URL = "";

function App() {
  const [isAuth, setIsAuth] = useState(false);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("auth_token");
    if (!token) {
      setChecking(false);
      return;
    }
    fetch(`${BACKEND_URL}/api/auth/me`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => {
        if (res.ok) setIsAuth(true);
        else localStorage.removeItem("auth_token");
      })
      .catch(() => localStorage.removeItem("auth_token"))
      .finally(() => setChecking(false));
  }, []);

  const handleLogin = () => setIsAuth(true);
  const handleLogout = () => {
    localStorage.removeItem("auth_token");
    localStorage.removeItem("auth_nome");
    setIsAuth(false);
  };

  if (checking) {
    return <div className="min-h-screen flex items-center justify-center bg-slate-50"><div className="animate-pulse text-slate-400">Caricamento...</div></div>;
  }

  return (
    <div className="App">
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <Routes>
          {/* Route pubblica - presentazione condivisa per i clienti */}
          <Route path="/p/:token" element={<SharedPresentation />} />
          
          {/* Route protette - portale */}
          <Route path="/" element={isAuth ? <PreventivoBuilder onLogout={handleLogout} /> : <LoginPage onLogin={handleLogin} />} />
          <Route path="/modifica/:id" element={isAuth ? <PreventivoBuilder onLogout={handleLogout} /> : <LoginPage onLogin={handleLogin} />} />
          <Route path="/dashboard" element={isAuth ? <Dashboard onLogout={handleLogout} /> : <LoginPage onLogin={handleLogin} />} />
          <Route path="/presentazione/:id" element={isAuth ? <PresentationView /> : <LoginPage onLogin={handleLogin} />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
